module.exports = __webpack_public_path__ + "img/joe_post.49257687.png";